/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { AddressFragmentDoc } from '../../../../graphql/fragments/CustomerData.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type ActiveCartDeliveryDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveCartDeliveryDetailsQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly deliveryOrderDetail: {
      readonly __typename: 'DeliveryOrderDetail';
      readonly id: string;
      readonly address: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly name: string | null;
        readonly city: string;
        readonly state: string;
        readonly zipCode: string;
        readonly country: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly notes: string | null;
      } | null;
    } | null;
  } | null;
};

export const ActiveCartDeliveryDetailsDocument = gql`
  query ActiveCartDeliveryDetails {
    cart {
      id
      __typename
      deliveryOrderDetail {
        id
        __typename
        address {
          ...address
        }
      }
    }
  }
  ${AddressFragmentDoc}
`;

export function useActiveCartDeliveryDetailsQuery(
  options?: Omit<Urql.UseQueryArgs<ActiveCartDeliveryDetailsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ActiveCartDeliveryDetailsQuery, ActiveCartDeliveryDetailsQueryVariables>({
    query: ActiveCartDeliveryDetailsDocument,
    ...options,
  });
}
